module.exports = __webpack_public_path__ + "media/hk_3F RM3.545ce824.mp4";